export default __webpack_public_path__ + "static/media/separation-group.6479b3bf.svg";